import { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useAuth } from '@/auth/hooks/useAuth';
import { DashboardPage } from './DashboardPage';
import { SubscriptionPage } from './SubscriptionPage';
import { RewardHistoryPage } from './RewardHistoryPage';
import { AdminDashboardPage } from './AdminDashboardPage';
import { AdminGamesPage } from './AdminGamesPage';
import { AdminGameDetailPage } from './AdminGameDetailPage';
import { AdminLimitsPage } from './AdminLimitsPage';
import { AdminTiersPage } from './AdminTiersPage';
import { AdminSubscriptionsPage } from './AdminSubscriptionsPage';
import { AdminRewardLogPage } from './AdminRewardLogPage';
import { LeaderboardPage } from './LeaderboardPage';
import { TimePlayedPage } from './TimePlayedPage';
import { StorePage } from './StorePage';

export function GameRewardsArchePage() {
  const { user } = useAuth();
  const isAdmin = useMemo(() => user?.roles?.includes('admin') ?? false, [user?.roles]);

  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
        <Route path="/store" element={<StorePage />} />
        <Route path="/rewards" element={<RewardHistoryPage />} />
        <Route path="/leaderboards" element={<LeaderboardPage />} />
        <Route path="/time-played" element={<TimePlayedPage />} />
        {isAdmin ? (
          <>
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/games" element={<AdminGamesPage />} />
            <Route path="/admin/games/:gameConfigId" element={<AdminGameDetailPage />} />
            <Route path="/admin/limits" element={<AdminLimitsPage />} />
            <Route path="/admin/tiers" element={<AdminTiersPage />} />
            <Route path="/admin/subscriptions" element={<AdminSubscriptionsPage />} />
            <Route path="/admin/reward-log" element={<AdminRewardLogPage />} />
          </>
        ) : (
          <Route path="/admin/*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </ArcheLayout>
  );
}
